import { applySnapshot, types } from "mobx-state-tree";
import i18n from "../../i18n";
import { IInput } from "../../utils/common-interface";
import { getMonthByIndex } from "../../utils/get-month-by-index";
import customtypes from "../../utils/mobx-types-helper";
import { ActionModel } from "../org/OrganizeModel";
import { SelectListModel } from "../share";

export const PlanEmailManagementModel = types
  .model("PlanEmailManagementModel", {
    isApprove: types.maybeNull(types.string),
    approveEmail: types.maybeNull(types.string),
    approveDateTime: types.maybeNull(types.string)
  })
  .views((self) => ({
    // เพิ่ม computed values ถ้าต้องการ
    // get isApproved(): boolean {
    //   return typeof self.isApprove === 'boolean' ? self.isApprove : self.isApprove === "true";
    // },
    
    get formattedApproveDateTime(): string {
      if (!self.approveDateTime) return "";
      return new Date(self.approveDateTime).toLocaleDateString('th-TH');
    }
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    }
  }));
export type IPlanEmailManageMentModel = typeof PlanEmailManagementModel.Type;

export const PlanReviewModel = types
  .model("PlanReviewModel", {
    reviewDate: customtypes.optional(types.string, ""),
    resultStatus: customtypes.optional(types.string, ""),
    resultDescription: customtypes.optional(types.string, ""),
    comment: customtypes.optional(types.string, "")
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    }
  }));
export type IPlanReviewModel = typeof PlanReviewModel.Type;

export const PlanStatusLogModel = types
  .model("PlanStatusLogModel", {
    id: customtypes.optional(types.number, 0),
    userID: customtypes.optional(types.string, ""),
    userName: customtypes.optional(types.string, ""),
    actionTime: customtypes.optional(types.string, ""),
    action: customtypes.optional(types.string, ""),
    actionType: customtypes.optional(types.string, ""),
    remark: customtypes.optional(types.string, "")
  })
  .views((self: any) => ({
    //
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    }
  }));
export type IPlanStatusLogModel = typeof PlanStatusLogModel.Type;

export const PlanHeaderModel = types
  .model("PlanHeaderModel", {
    planID: customtypes.optional(types.number, 0),
    planCode: customtypes.optional(types.string, ""),
    planYear: customtypes.optional(types.number, 0),
    planYearTxt: customtypes.optional(types.string, ""),
    month: types.maybeNull(types.number),
    planRelease: customtypes.optional(types.string, ""),
    createLog: types.maybeNull(ActionModel),
    changeLog: types.maybeNull(ActionModel),
    planStatus: customtypes.optional(types.string, ""),
    organization: types.optional(SelectListModel, {}),
    proposals: types.optional(types.array(SelectListModel), []),
    reviewComment: customtypes.optional(PlanReviewModel, {}),
    planStatusLog: customtypes.optional(PlanStatusLogModel, {}),
    emailManagement: customtypes.optional(PlanEmailManagementModel, {})
  })
  .views((self: any) => ({
    get changeLogActionTime() {
      return self.changeLog ? self.changeLog.actionTime || "-" : "-";
    },
    get changeLogUsername() {
      return self.changeLog ? self.changeLog.userName || "-" : "-";
    },
    get createLogActionTime() {
      return self.createLog ? self.createLog.actionTime || "-" : "-";
    },
    get createLogUsername() {
      return self.createLog ? self.createLog.userName || "-" : "-";
    },
    get planHeaderJSON() {
      return self.toJSON();
    },
    get description() {
      return `ปี ${self.planYear} ${self.planRelease} ${self.planCode}`;
    },
    get monthName() {
      return getMonthByIndex(self.month);
    },
    get monthNameShort() {
      return getMonthByIndex(self.month, true);
    },
    get planIdView() {
      return self.planID ? self.planID : "";
    }
  }))
  .actions((self: any) => ({
    setField: ({ fieldname, value }: IInput) => {
      self[fieldname] = value;
    }
  }));
export type IPlanHeaderModel = typeof PlanHeaderModel.Type;
